import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DashboardDateRangeFilter } from '../dashboard-filter/dashboard-filter-type.enum';
import { campsenum } from '../../../models/enums.generated';




@Component({
    selector: 'app-dashboard-filter',
    templateUrl: './dashboard-filter.component.html',
    styleUrls: ['./dashboard-filter.component.scss'],
    standalone: false
})
export class DashboardFilterComponent implements OnInit {

    @Input()
    public filterForm: UntypedFormGroup;

    public dateRangeValues: DashboardDateRangeFilter[] = [
        DashboardDateRangeFilter.Last30Days,
        DashboardDateRangeFilter.CurrentMonth,
        DashboardDateRangeFilter.LastMonth,
        DashboardDateRangeFilter.CurrentYear,
        DashboardDateRangeFilter.LastYear,
        DashboardDateRangeFilter.NoFilter];

        public campTypeValues: campsenum.CampType[] = [
            null,
            campsenum.CampType.Standard,
            campsenum.CampType.Childcare,
            campsenum.CampType.School,
            campsenum.CampType.AfterSchool,
            campsenum.CampType.Summer];

    constructor(private translate: TranslateService) { }

    ngOnInit() {
    }

    public setFilter(filter: DashboardDateRangeFilter): void {
        this.filterForm.controls['dateRange'].setValue(filter);
    }

    public setCampTypeFilter(filter: campsenum.CampType): void {
        this.filterForm.controls['campType'].setValue(filter);
    }

    public get translateSelectedFilter() {
        return this.translateFilter(this.filterForm.controls['dateRange'].value)
    }

    public translateFilter(filter: DashboardDateRangeFilter) {
        let key = "DashboardDateRangeFilter." + DashboardDateRangeFilter[filter];
        return this.translate.instant(key);
    }

    public get translateSelectedCampTypeFilter() {
        return this.translateCampTypeFilter(this.filterForm.controls['campType'].value)
    }

    public translateCampTypeFilter(campType: campsenum.CampType) {
        if(campType == null) { return 'All types'; }

        let key = "CampType." + campsenum.CampType [campType];
        return this.translate.instant(key);
    }
}
